import React from 'react';
import type { PropsWithChildren } from 'react';

import { AuthProvider } from '@reckon-web/auth-store';

import { Config } from '../Config';
import { Loader } from '../../components/design-system/Loader';

import { PortalUrlFragmentManager } from './PortalUrlFragmentManager';

export type PortalAuthProviderProps = PropsWithChildren<{}>;

export const PortalAuthProvider = ({ children }: PortalAuthProviderProps) => {
  return (
    <AuthProvider
      storagePrefix={`${Config.APPLICATION_LOCALSTORAGE_PREFIX}`}
      onLogout={() => {
        window.location.href = Config.APPLICATION_PORTAL_LOGIN_URL;
      }}
    >
      <PortalUrlFragmentManager>
        <AuthProvider.IsLoading loader={<Loader label="Loading" />}>
          {children}
        </AuthProvider.IsLoading>
      </PortalUrlFragmentManager>
    </AuthProvider>
  );
};
